/**
 * ID serveur (cuid) vs clé React temporaire.
 * @param {unknown} id
 */
export function isPersistedPrismaId(id) {
  if (typeof id !== 'string') return false;
  if (id.startsWith('temp-')) return false;
  return id.length >= 20;
}
